export default __webpack_public_path__ + "static/media/60t.cc6ab970.jpg";